export const errors = (state) => { return state.errors };
export const promoter = (state) => { return state.promoter };
export const promoters = (state) => { return state.promoters };
export const validatePromoter = (state) => { return state.validatePromoter };
export const promoterValidated = (state) => { return state.promoterValidated };
export const validatePromoterAccount = (state) => { return state.validatePromoterAccount };
export const promoterAccountValidated = (state) => { return state.promoterAccountValidated };
